<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">{{ utils.getLangTerm('hazardous-substances.list.account-title', 'Hazardous Substances') }}</span>

    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button
          *ngIf="canCreate"
          mat-raised-button
          color="primary"
          routerLink="/hazardous_substances/new/edit"
          class="m-1 mr-2"
          id="add">
          <mat-icon>add</mat-icon>
          Add
        </button>

        <ng-container *ngIf="canDelete || canView">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>
            <!-- Export requires View: users must not export data they cannot see. -->
            <ng-container *ngIf="canView">
              <button mat-menu-item (click)="onExportSelected('pdf')">
                <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? 'Selected' : 'All' }} to PDF
              </button>
              <button mat-menu-item (click)="onExportSelected('csv')" matTooltip="Export Summary to CSV ({{ dataSource.selection.hasValue() ? 'Selected' : 'All' }})">
                <mat-icon>cloud_download</mat-icon> Export Summary to CSV ({{ dataSource.selection.hasValue() ? 'Selected' : 'All' }})
              </button>
              <button mat-menu-item (click)="onExportSelected('xlsx')" matTooltip="Export Full Report to XLSX ({{ dataSource.selection.hasValue() ? 'Selected' : 'All' }})">
                <mat-icon>cloud_download</mat-icon> Export Full Report to XLSX ({{ dataSource.selection.hasValue() ? 'Selected' : 'All' }})
              </button>
            </ng-container>
            <button *ngIf="canDelete" mat-menu-item (click)="onDeleteSelected()" [disabled]="!dataSource.selection.hasValue()">
              <mat-icon>delete</mat-icon> Delete Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect and/or export records." style="min-width: 150px">
            <mat-icon>more_vert</mat-icon>
            List Menu/Export
          </button>
        </ng-container>
      </span>

      <ng-container *ngIf="canView">
        <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
          <mat-icon>filter_list</mat-icon> Filter
        </button>

        <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
          <input
            class="form-control ml-0 mr-2 my-1"
            type="search"
            [(ngModel)]="dataSource.search"
            name="search"
            placeholder="Search"
            aria-label="Search"
            matTooltip="Search by name" />

          <button
            mat-raised-button
            color="secondary"
            type="submit"
            class="mx-0 my-1"
            matTooltip="Run the current search">
            <mat-icon>search</mat-icon> Search
          </button>
        </form>
      </ng-container>

    </div>
  </nav>

  <div class="alert alert-warning m-2" *ngIf="!canView">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view hazardous substances.
    <span *ngIf="canCreate">You can still create new hazardous substances using the button above.</span>
    <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
  </div>

  <div class="mat-elevation-z8 scroll-box" *ngIf="canView">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="substance" matSortDirection="asc" matSortDisableClear>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
            matTooltip="Toggle selecting all records on the page.">
          </mat-checkbox>
        </th>

        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(row.id) : null"
            [checked]="dataSource.selection.isSelected(row.id)"
            matTooltip="Toggle selecting this record.">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by substance ID">
          #
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.id }}
        </td>
      </ng-container>

      <!-- Hazardous Substance -->
      <ng-container matColumnDef="substance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
          matTooltip="Toggle sorting by substance">
          {{ utils.getLangTerm('hazardous-substances.singular', 'Hazardous Substance') }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.substance }}
        </td>
      </ng-container>

      <!-- Hazardous Substance Type -->
      <ng-container matColumnDef="hazardous_substance_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by type">
          Type
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element?.hazardous_substance_type">
            {{ ('(' + element?.hazardous_substance_type?.substring(0, 1) + ') ') + element.hazardous_substance_type }}
          </ng-container>
        </td>
      </ng-container>

      <!-- Hazardous Substance Unit Type -->
      <ng-container matColumnDef="hazardous_substance_unit_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by unit type">
          Unit Type
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.hazardous_substance_unit_type }}
        </td>
      </ng-container>

      <!-- Hazardous Substance Quantity -->
      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef matTooltip="The quantity that is currently held on all site.">
          Quantity (All Sites)
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.quantity || '' }}
        </td>
      </ng-container>

      <!-- Hazardous Substance Max Allowed Quantity -->
      <ng-container matColumnDef="max_quantity_allowed">
        <th mat-header-cell *matHeaderCellDef matTooltip="The max quantity that is allowed to be held on all site.">
          Max Quantity Allowed (All Sites)
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.max_quantity_allowed || '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sds_expires_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>SDS Expires At</th>
        <td mat-cell *matCellDef="let element">
          {{ element.sds_expires_at ? ((element.sds_expires_at * 1000) | timezoneConvertMedium) : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</th>
        <td mat-cell *matCellDef="let element">
          {{ (element.date_created * 1000) | timezoneConvertMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created_UTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Created (UTC)</th>
        <td mat-cell *matCellDef="let element">
          {{ (element.date_created * 1000) | timezoneConvertUTCMedium }}
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="300"></th>

        <td mat-cell *matCellDef="let element">
          <button type="button" mat-button [routerLink]="'/hazardous_substances/' + element.id + '/view'">
            View
          </button>

          <button type="button" mat-button [routerLink]="'/hazardous_substances/' + element.id + '/edit'" *ngIf="canEdit">
            Edit
          </button>

          <button type="button" mat-button (click)="onCreateFrom(element)" *ngIf="canCreate">
            Clone
          </button>

          <button type="button" mat-button (click)="onRemove(element.id)" *ngIf="canDelete">
            Delete
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [length]="dataSource?.total | async"
      [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
